export const sortByPlaceInWeek = (a: any, b: any) => {
    // sort by day of the week first, then by time
    const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const [aDay, aTime] = a.time.split(' ');
    const [bDay, bTime] = b.time.split(' ');
    if (aDay === bDay) {
        return aTime.localeCompare(bTime);
    }
    return dayOrder.indexOf(aDay) - dayOrder.indexOf(bDay);
}

export const toClassTimeListObject = (acc: any[], course: any) => {
    if (course.timesOfWeek && course.timesOfWeek.length > 0) {
        course.timesOfWeek.forEach((time: string) => {
            if (!acc.includes(time)) {
                acc.push({
                    id: course.id,
                    time: time,
                    program: course.program || '',
                    classLabel: course.classLabel || '',
                    level: course.level || '',
                    communityCode: course.SKU.split('-')[0],
                });
            }
        });
    }
    return acc;
};
